import { createBrowserRouter, Navigate } from 'react-router'
import { LoginPage } from '@/features/auth/LoginPage'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { ProtectedRoute } from '@/shared/components/ProtectedRoute'
import { PublicRoute } from '@/shared/components/PublicRoute'
import { ROUTES } from '@/shared/routes'

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [{ path: ROUTES.LOGIN, element: <LoginPage /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [{ path: ROUTES.HOME, element: <DashboardPage /> }],
  },
  { path: '*', element: <Navigate to={ROUTES.HOME} replace /> },
])
